import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        gtag('config', 'G-K0JXBQKP8J',
          {
            'page_path': event.urlAfterRedirects,
            cookie_flags: 'Secure'
          }
        );
      }
    });
  }

  title = 'rahilhastu';

  ngOnInit(): void { }

  socialMedia() {
    console.log('Clicking');
    let downArrow = document.querySelector('.fa-angle-down');
    let upArrow = document.querySelector('.fa-angle-up');
    let mediaTray = document.querySelector('.media-tray');
    mediaTray.classList.toggle('clickTodisplay');
    downArrow.classList.toggle('fa-angle-down-display');
    upArrow.classList.toggle('fa-angle-up-display');
  }
}
